let api = process.env.REACT_APP_MKGF_MASTODON_API+'/conversation'

// This is the sidecar's own "bare details" conversation store — participants +
// a Mastodon status id (+ an optional event) — not to be confused with
// controllers/message/conversation.js, which talks to Mastodon's own
// /api/v1/conversations endpoint directly.

export const createConversation = async ({ token, participants, status_id, event_id, author_id }) => {
    let body = { participants, status_id, event_id, author_id }
    const headers = { 'Authorization': 'Bearer '+token, 'Content-Type': 'application/json' }
    const response = await fetch(api+"/" , { method:"POST", headers, body:JSON.stringify(body) });
    const data = await response.json();
    return data
}

export const markConversationRead = async ({ token, id, user }) => {
    let body = { user }
    const headers = { 'Authorization': 'Bearer '+token, 'Content-Type': 'application/json' }
    const response = await fetch(api+"/"+id+"/read" , { method:"POST", headers, body:JSON.stringify(body) });
    const data = await response.json();
    return data
}

export const touchConversation = async ({ token, id, author }) => {
    let body = { author }
    const headers = { 'Authorization': 'Bearer '+token, 'Content-Type': 'application/json' }
    const response = await fetch(api+"/"+id+"/activity" , { method:"POST", headers, body:JSON.stringify(body) });
    const data = await response.json();
    return data
}

export const getMyConversations = async (token, mastodon_id) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const response = await fetch(api+"/mine?mastodon_id="+mastodon_id , { headers });
    const data = await response.json();
    return data
}

export const getMyEventConversations = async (token, mastodon_id) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const response = await fetch(api+"/mine/events?mastodon_id="+mastodon_id , { headers });
    const data = await response.json();
    return data
}

export const getConversation = async (token, id) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const response = await fetch(api+"/"+id , { headers });
    const data = await response.json();
    return data
}

export const deleteMyConversation = async ({token, id}) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const response = await fetch(api+"/"+id , { method:"DELETE", headers });
    const data = await response.json();
    return data
}
